import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';

export default function useUserLanguages(userId) {
  const [availableLanguages, setAvailableLanguages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;
    setIsLoading(true);
    const fetchLanguages = async () => {
      try {
        const pagesRef = collection(db, `users/${userId}/pages`);
        const snapshot = await getDocs(pagesRef);
        const languages = new Set(snapshot.docs.map(doc => doc.data().language));
        setAvailableLanguages(Array.from(languages));
      } catch (error) {
        setAvailableLanguages([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchLanguages();
  }, [userId]);

  return { availableLanguages, isLoading };
} 